export default __webpack_public_path__ + "static/media/searchIcon.30f23e6e.svg";